import React from "react"
import classNames from "classnames"

interface PropsType {
  containerClassName?: string,
  spinnerClassName?: string,
}

const Loader = (props: PropsType) => {
  const {
    containerClassName,
    spinnerClassName
  } = props;

  return (
    <div className={classNames("loader-container", containerClassName)}>
      <div className={classNames("spinner-border", spinnerClassName)} role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  )
}

export default Loader;
